<style lang="less">
@media only screen and (max-height: 360px) {
	.check_circular{
		display: none !important;
	}
}

.check_circular{
	width: 100%;
	img{
		width: 20px;
	}
	.book{
		color: #c62520;
		font-weight: 600;
	}
}
</style>

<template>
	<!-- Main check_circular -->
	<div class="check_circular">
		<img v-if="agree" src="../assets/icon_multiple.png" />
		<img v-else src="../assets/icon_multiple_disable.png" />
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
			};
		},
		components: {
		},
		props: {
			agree: {
				type: Boolean,
				default: true
			}
		},
		mounted: function () {
		},
		methods: {

		}
	};
</script>


// WEBPACK FOOTER //
// src/components/check_circular.vue